var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"in-dm-media"},[(_setup.isVideo && !_setup.isVideoError)?_c('video',{ref:"videoRef",staticClass:"in-dm-media__video",attrs:{"src":_vm.url,"muted":"","autoplay":"","playsinline":""},domProps:{"muted":true},on:{"error":_setup.onVideoError}}):_c(_setup.InDmImage,{attrs:{"url":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }